<template>
    <div class="kgk-logout">
        <LogoutForm />
    </div>
</template>

<script>
    // @ is an alias to /src
    import LogoutForm from '@/components/login/LogoutForm.vue';

    export default {
        name: 'Logout',
        components: {
            LogoutForm,
        }
    }
</script>
